import styled from 'styled-components';

export const Wrapper = styled.div`
  display: inline-flex;
  width: auto;
  padding: 5px;
  margin-left: 3px;
  background: #f0d60b;
  color: #4c4f52;
  font-size: 8px;
  font-weight: bold;
  line-height: 4px;
  border-radius: 8px;
`;
